import { sceneState, type SceneState } from '@/lib/threeScene/SceneContext';
import { type StandardNode } from '@/lib/threeScene/updateNode';
import { imagePlaneNode, type ImagePlaneNode } from '@/lib/threeScene/nodes/imagePlane';
import { renderingState, type RenderingState } from '@/lib/threeScene/renderingState';
import { createImageViewerCameraState } from '@/lib/threeScene/cameras/imageViewerCamera';
import { vector3 } from '@/domain/geometry/vector3';
import {
    XRAY_CAMERA_FRUSTUM_HEIGHT,
    XRAY_CAMERA_TARGET_DISTANCE,
} from '@/views/dicoms/xrays/xraySceneState';
import type { AnnotationGroup } from '../types';

export type HipSpineXraySceneNode = StandardNode;

export type HipSpineXraySceneState = SceneState<HipSpineXraySceneNode> & {
    rendering: RenderingState;
    /**
     * Global image-adjustment intent, projected onto the scene state by the
     * image-controls ViewModel. The scene reads these via `context.state` and
     * writes them to the active posture's shader uniforms, so the scene module
     * never imports a Pinia store. Neutral defaults match the shader's uniform
     * defaults (see `makeHipSpineXRayMaterial`): brightness 0 (no offset),
     * contrast 1 (no scaling).
     */
    imageAdjustments: { brightness: number; contrast: number };
    nodes: {
        imagePlane: ImagePlaneNode;
        annotationGroups: AnnotationGroup[];
        angleGroups: AnnotationGroup[];
    };
};

export function hipSpineXraySceneState(): HipSpineXraySceneState {
    return {
        ...sceneState(),
        rendering: renderingState({
            camera: createImageViewerCameraState({
                position: vector3(0, 0, XRAY_CAMERA_TARGET_DISTANCE),
                up: vector3(0, 1, 0),
                height: XRAY_CAMERA_FRUSTUM_HEIGHT,
            }),
        }),
        imageAdjustments: { brightness: 0, contrast: 1 },
        nodes: {
            imagePlane: imagePlaneNode('hip-spine-xray', { visible: false }),
            annotationGroups: [],
            angleGroups: [],
        },
    };
}
